import React, { useState, useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import _ from "lodash";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import { useForm, Controller } from "react-hook-form";
import SwalMessage from "../_Components/SwalMessage";
import { Link, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/CloseRounded";
import SaveIcon from "@mui/icons-material/SaveRounded";
// import "./PromoCategory.css";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import { tools } from "../../../core/utils/tools";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import HTMLInput from "../_Components/HTMLInput";
import ApiRegion from "../../../core/api/api.region";
const CreateEditAmusementServicePromoCategory = (props) => {
  const [treeViewData, setTreeViewData] = useState([]);
  const [promoCategory, setPromoCategory] = useState();
  const [list, setList] = useState();
  const [amusementGroups, setAmusementGroups] = useState([]);
  const [amusementCities, setAmusementCities] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    register,
    reset,
    watch,
    formState: { isSubmitting },
  } = useForm();

  const {
    control: searchControl,
    handleSubmit: handleSearchSubmit,
    formState: { isSubmitting: isSearchSubmitting },
    reset: resetSearch,
    watch: watchSearch,
  } = useForm();

  let { id } = useParams();
  const handleChange = (ee, elementName, typeName) => {
    setValue(elementName, ee.target.value.replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    let splitElmenet = elementName.split(typeName);
    calculaterPriceNextDiscount(splitElmenet[0], splitElmenet[1]);
  };
  const getAmusemntServices = async (cityIdList, groupIdList) => {
    try {
      setLoadingData(true);
      const response = await ApiAmusementService.getAllServices({
        cityIdList: cityIdList,
        groupIdList: groupIdList,
      });
      const apiData2 = response.map((item) => ({
        serviceId: item.id,
        serviceName: item.name,
        amusementServiceReserveItems: item.amusementServiceReserveItems,
      }));
      setTreeViewData(apiData2);
    } catch (error) {
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        // getAmusemntServices();
        //================Get Cities And Groups
        const [groupsResponse, citiesResponse] = await Promise.all([
          ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 }),
          ApiRegion.getAllCity(),
        ]);
        setAmusementGroups(groupsResponse.data);
        setAmusementCities(citiesResponse);
        //================Get PromoCategory
        if (id !== undefined) {
          let response = await ApiPromoCategory.GetPromoCategoryAmusementServiceById(id);
          if (response != null) {
            setPromoCategory(response[0].promoCategoryName);
            //setList(response);
            //پرکردن آیتم ها
            response.map((item) => {
              let parsAmusementServiceFormFieldIds = JSON.parse(item.amusementServiceFormFieldIds);
              let tt = parsAmusementServiceFormFieldIds?.map((nodes) => {
                if (nodes.discountprice != 0) {
                  setValue(
                    item.amusementServiceId + "pricediscount" + nodes.id,
                    nodes.discountprice
                      .toString()
                      .replace(/[^0-9]/g, "")
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                  );
                  //setValue(item.amusementServiceId + "pricediscount" + nodes.id, "12556");
                }
                if (nodes.discountPricePercent != 0)
                  setValue(
                    item.amusementServiceId + "percentdiscount" + nodes.id,
                    nodes.discountPricePercent
                      .toString()
                      .replace(/[^0-9]/g, "")
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                  );
                calculaterPriceNextDiscount(item.amusementServiceId, nodes.id);
              });
            });
          }
          else {
            SwalMessage({ title: "گروه تخفیف مورد نظر پیدا نشد.", iSsuccess: false });
          }
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  function calculaterPriceNextDiscount(amusementServiceId, nodeId, elementName, e) {
    let Price = parseInt((getValues(amusementServiceId + "Price" + nodeId) + "").replaceAll(",", ""));
    let DisCountPrice = parseInt((getValues(amusementServiceId + "pricediscount" + nodeId) + "").replaceAll(",", ""));
    let OrginalPrice = parseInt((getValues(amusementServiceId + "orginalPrice" + nodeId) + "").replaceAll(",", ""));
    let PercentDiscount = parseInt(
      (getValues(amusementServiceId + "percentdiscount" + nodeId) + "").replaceAll(",", ""),
    );
    let calc = Price - DisCountPrice - OrginalPrice * (PercentDiscount / 100);
    setValue(
      amusementServiceId + "priceAfterDiscount" + nodeId,
      calc
        .toString()
        .replace(/[^0-9]/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    );
  }

  const formatNumber = (value) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const onSubmit = async (data) => { // ذخیره تغییرات
    try {
      let objData = [];
      Object.keys(data).map((item) => {
        let split = [];
        let isInFetchedData = false;
        if (item.indexOf("pricediscount") != -1 || item.indexOf("percentdiscount") != -1) {
          if (item.indexOf("pricediscount") != -1) {
            split = item.split("pricediscount");
            let aaaa = _.find(list, { amusementServiceId: _.toNumber(split[0]) });
            if (aaaa != undefined) {
              let bbbb = _.find(JSON.parse(aaaa?.amusementServiceFormFieldIds), { id: split[1] });
              if (!_.isEmpty(bbbb) && !_.isEmpty(bbbb.discountprice)) {
                isInFetchedData = true;
              }
            }
          } else if (item.indexOf("percentdiscount") != -1) {
            split = item.split("percentdiscount");
            let aaaa = _.find(list, { amusementServiceId: _.toNumber(split[0]) });
            if (aaaa != undefined) {
              let bbbb = _.find(JSON.parse(aaaa.amusementServiceFormFieldIds), { id: split[1] });
              if (!_.isEmpty(bbbb) && !_.isEmpty(bbbb.discountprice)) {
                isInFetchedData = true;
              }
            }
          }
          ////////////////////////////////////////////////////////////
          if ((!_.isEmpty(getValues(item)) && !_.isUndefined(getValues(item))) || isInFetchedData) {
            let resITem = objData?.find((item) => item.amusementServiceId == split[0]);
            if (_.isUndefined(resITem)) {
              objData.push({
                amusementServiceId: split[0],
                amusementServiceFormFieldIds: [
                  {
                    id: split[1],
                    discountprice: item.indexOf("pricediscount") != -1 ? getValues(item).replaceAll(",", "") : 0,
                    discountPricePercent:
                      item.indexOf("percentdiscount") != -1 ? getValues(item).replaceAll(",", "") : 0,
                  },
                ],
                promoCategoryId: id,
              });
            } else {
              let objamusService = resITem.amusementServiceFormFieldIds.find((item) => item.id == split[1]);
              if (_.isUndefined(objamusService)) {
                resITem.amusementServiceFormFieldIds.push({
                  id: split[1],
                  discountprice: item.indexOf("pricediscount") != -1 ? getValues(item).replaceAll(",", "") : 0,
                  discountPricePercent: item.indexOf("percentdiscount") != -1 ? getValues(item).replaceAll(",", "") : 0,
                });
              } else {
                if (item.indexOf("pricediscount") != -1)
                  objamusService.discountprice = getValues(item).replaceAll(",", "") || 0;
                else if (item.indexOf("percentdiscount") != -1)
                  objamusService.discountPricePercent = getValues(item).replaceAll(",", "") || 0;
              }
            }
          }
        }
      });
      let tt = objData?.map((item) => {
        return (item.amusementServiceFormFieldIds = JSON.stringify(item.amusementServiceFormFieldIds));
      });

      // set the discountprice and  discountPricePercent to 0 if the content is empty
      const convertedObjData = objData.map((item) => {
        const amusementServiceFormFieldIds = JSON.parse(item.amusementServiceFormFieldIds);
        const newAmusementServiceFormFieldIds = amusementServiceFormFieldIds.map((item) => {
          if (item.discountprice == "") {
            item.discountprice = 0;
          }
          if (item.discountPricePercent == "") {
            item.discountPricePercent = 0;
          }

          return item;
        });
        return {
          ...item,
          amusementServiceFormFieldIds: JSON.stringify(newAmusementServiceFormFieldIds),
        };
      });

      let response = await ApiPromoCategory.addOrEditPromoCategoryAmusmentService({
        PromoCategoryAmusmentServiceId: id,
        promoCategoryAmusmentServiceModel: convertedObjData,
      });

      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };
  const onSubmit1 = async (data) => { //جست و جو

    if (data.cityIdList?.length > 0) data.cityIdList = _.toString(data.cityIdList?.map((item) => item.value));
    if (data.groupIdList?.length > 0) data.groupIdList = _.toString(data.groupIdList?.map((item) => item.value));
    await getAmusemntServices(data.cityIdList, data.groupIdList);

  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">تخفیف گروه "{promoCategory}"</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              افزودن یا ویرایش تخفیف گروه "{promoCategory}" برای تفریحات
            </span>
          </h3>
          <div className="">
            <Link className="btn btn-danger ml-3" to="/promoCategory">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </div>
        <form noValidate autoComplete="off" className="mt-3 px-4" onSubmit={handleSearchSubmit(onSubmit1)}>
          <Row className="pb-5 border-bottom">
            <Col sm="6" xl="3" className="ps-xl-1">
              <Controller
                name="cityIdList"
                control={searchControl}
                render={({ field }) => (
                  <SelectComponent
                    className=" mt-2"
                    placeholder=" شهر"
                    options={amusementCities?.map((item) => ({
                      value: item.id,
                      label: item.id + "-" + item.name,
                    }))}
                    isMulti
                    field={field}
                  />
                )}
              />
            </Col>
            <Col sm="6" xl="3" className="ps-xl-1">
              <Controller
                name="groupIdList"
                control={searchControl}
                render={({ field }) => (
                  <SelectComponent
                    className=" mt-2"
                    placeholder=" دسته تفریح"
                    options={amusementGroups?.map((item) => ({ value: item.id, label: item.title }))}
                    isMulti
                    field={field}
                  />
                )}
              />
            </Col>
            <Col xs="12" xl="auto" className="ps-xl-1">
              <Button
                variant="success"
                type="submit"
                className="mt-5 mt-md-2 px-5"
                color="success"
                style={{ height: "40px" }}
              >
                {isSearchSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SearchIcon />
                جستجو
              </Button>
              {/* <Button
                style={{ height: "40px" }}
                variant="light-danger"
                className="mt-5 mt-md-2 me-3"
                type="submit"
                disabled={isSearchSubmitting}
                onClick={() => tools.handleResetAdvanceSearchBox(watchSearch, resetSearch)}
              >
                {isSearchSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <i className="fas fa-refresh text-small"></i>
                حذف جستجو
              </Button> */}
            </Col>
          </Row>
        </form>
        {/*Start body */}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-4 my-4">
            {!loadingData ? (
              treeViewData.map((service, index) => (
                <Col key={index} xs="12" className="mt-3 px-0">
                  <Accordion className="border" key={service.serviceId}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${service.serviceId}-content`}
                      id={`panel${service.serviceId}-header`}
                    >
                      <div className="font-weight-bolder">{service.serviceName}</div>
                    </AccordionSummary>
                    <AccordionDetails className="border-top">
                      <ol className="p-0 pl-3 ol-blue">
                        {service.amusementServiceReserveItems?.map((item) => (
                          <li
                            key={`${service.serviceId}-${item.id}`}
                            style={{ marginBottom: "1rem", marginTop: "1rem" }}
                          >
                            <h5 className="pb-3 mt-5 text-primary">{item.title}</h5>
                            <Row className="pb-5 mb-3 border-bottom border-primary-subtle">
                              <Col xs="12" sm="4" lg className="mb-5 mb-lg-0">
                                <HTMLInput
                                  label="تخفیف به تومان"
                                  placeholder="تخفیف به تومان"
                                  registeredParams={{ ...register(`${service.serviceId}pricediscount${item.id}`) }}
                                  onChange={(e) =>
                                    handleChange(e, `${service.serviceId}pricediscount${item.id}`, "pricediscount")
                                  }
                                  className="form-control"
                                />
                              </Col>
                              <Col xs="12" sm="4" lg className="mb-5 mb-lg-0">
                                <HTMLInput
                                  label="درصد تخفیف"
                                  placeholder="درصد تخفیف"
                                  registeredParams={{ ...register(`${service.serviceId}percentdiscount${item.id}`, { min: 0, max: 100 }) }}
                                  onChange={(e) => {
                                    if (+e.target.value > 100 || +e.target.value < 0) {
                                      e.target.value = getValues(`${service.serviceId}percentdiscount${item.id}`)
                                      return
                                    }
                                    handleChange(
                                      e,
                                      `${service.serviceId}percentdiscount${item.id}`,
                                      "percentdiscount",
                                    )
                                  }
                                  }
                                  className="form-control"
                                />
                              </Col>
                              <Col xs="12" sm="4" lg className="mb-5 mb-lg-0">
                                <HTMLInput
                                  label="قیمت اصلی"
                                  placeholder="قیمت اصلی"
                                  registeredParams={{ ...register(`${service.serviceId}orginalPrice${item.id}`) }}
                                  readOnly
                                  defaultValue={formatNumber(item.originalPrice.toString())}
                                  disabled
                                  className="form-control"
                                />
                              </Col>
                              <Col xs="12" sm="4" lg className="mb-5 mb-lg-0 ">
                                <HTMLInput
                                  label="قیمت"
                                  placeholder="قیمت"
                                  registeredParams={{ ...register(`${service.serviceId}Price${item.id}`) }}
                                  readOnly
                                  defaultValue={formatNumber(item.price.toString())}
                                  disabled
                                  className="form-control"
                                />
                              </Col>
                              <Col xs="12" sm="4" lg className="mb-5 mb-lg-0">
                                <HTMLInput
                                  label="قیمت بعد تخفیف"
                                  placeholder="قیمت بعد تخفیف"
                                  registeredParams={{ ...register(`${service.serviceId}priceAfterDiscount${item.id}`) }}
                                  className="form-control"
                                  onChange={e => {
                                    setValue(
                                      `${service.serviceId}priceAfterDiscount${item.id}`,
                                      e.target.value.replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    )
                                  }}
                                />
                              </Col>
                            </Row>
                          </li>
                        ))}
                      </ol>
                    </AccordionDetails>
                  </Accordion>
                </Col>
              ))
            ) : (
              <div className="px-4 py-4">در حال دریافت اطلاعات ...</div>
            )}
          </div>
          <div className="card-footer">
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon />
              ذخیره
            </Button>
            <Link className="btn btn-danger ml-3" to="/promoCategory">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
export default CreateEditAmusementServicePromoCategory;
